var parent = require('../../actual/instance/bind');

module.exports = parent;



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js-pure/full/instance/bind.js
// module id = 479
// module chunks = 0 1